<template>
    <el-header>
        <div class="sidebar-title">
            <h1>开源技术小栈直播中心</h1>
        </div>
        <div class="right-menu" v-if="!$store.state.isInfor">
            <div class="user-name">
                <span>Hello, {{ userName }}</span>
                <i class="iconfont icon-icon_dropdown_16px"></i>
            </div>
            <div class="user-logout">
                <div class="logout-item" @click="logout">退出系统</div>
            </div>
        </div>
    </el-header>
</template>

<script>
import { getuserInfo, removeToken, removerefToken, removeloginTime, removeExpiresTime, removeuserInfo } from '@/utils/auth'
export default {
    name: 'navbar',
    data() {
        return {
            userName: getuserInfo() ? JSON.parse(getuserInfo()).username : ''
        }
    },
    computed: {
    },
    created() {
    },
    methods: {
        logout() {
            this.$confirm('确定退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeToken()
                removerefToken()
                removeloginTime()
                removeExpiresTime()
                removeuserInfo()
                location.reload()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.el-header{
    height: 64px!important;
    position: relative;
    background: $headerBgColor;
    z-index: 9;
    padding: 0 0 0 32px;
    .sidebar-title{
        float: left;
        h1{
            display: inline-block;
            vertical-align: top;
            font-size: 22px;
            font-weight: 400;
            color: #fff;
            line-height: 64px;
        }
    }
    .right-menu {
        position: relative;
        float: right;
        height: 100%;
        line-height: 64px;
        .user-name {
            position: relative;
            color: #fff;
            font-size: 16px;
            font-weight: 400;
            padding: 0 32px;
            cursor: pointer;
            &:hover{
                background-color: $headerHoverColor;
            }
            span{
                margin-right: 8px;
            }
        }
        &:hover{
            .user-logout{
                display: block;
            }
        }
        .user-logout {
            position: absolute;
            display: none;
            width: 100%;
            padding: 8px 0;
            background-color: $headerBgColor;
            .logout-item{
                line-height: 44px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                cursor: pointer;
                &:hover{
                    background-color: $headerHoverColor;
                }
            }
        }
    }
}
</style>
